$(document).ready( function() {
	const $heroVideo = $('#hero-video');
	if ( $heroVideo.length > 0) {
		const mediaVideo = $heroVideo.get(0);
		const $btnMute = $('.js-video-controls .mute-control');
		const $btnPause = $('.js-video-controls .pause-control');
		$btnPause.on('click', ev => {
			if (mediaVideo.paused) {
				mediaVideo.play();
				$btnPause.find('.icon').removeClass('stop');
			} else {
				mediaVideo.pause();
				$btnPause.find('.icon').addClass('stop');
			}
		});
		$btnMute.on('click', ev => {
			if (mediaVideo.muted) {
				$btnMute.find('.icon').addClass('stop');
			} else {
				$btnMute.find('.icon').removeClass('stop');
			}
			mediaVideo.muted = !mediaVideo.muted;
		});
	}
});
